import { motion } from "framer-motion";
import { ContactActions, ContactDetails, ContactIntro, FooterSignature } from "./contact/ContactParts";

export { GarageCard } from "./GarageCard";

export const ContactFooter = ({ onTip }) => (
  <footer id="contact" className="relative pt-20 sm:pt-28 pb-10 overflow-hidden" data-testid="contact-footer">
    <div aria-hidden="true" className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(600px circle at 50% 100%, rgba(16,185,129,0.16), transparent 70%)" }} />
    <div className="max-w-4xl mx-auto px-5 sm:px-8 relative text-center">
      <motion.div initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.3 }} transition={{ duration: 0.75, ease: [0.16, 1, 0.3, 1] }}>
        <ContactIntro />
        <ContactActions onTip={onTip} />
        <ContactDetails />
      </motion.div>
      <FooterSignature />
    </div>
  </footer>
);